import { render, staticRenderFns } from "./ReportingBOR.vue?vue&type=template&id=217c9e94&scoped=true"
import script from "./ReportingBOR.vue?vue&type=script&lang=js"
export * from "./ReportingBOR.vue?vue&type=script&lang=js"
import style0 from "./ReportingBOR.vue?vue&type=style&index=0&id=217c9e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217c9e94",
  null
  
)

export default component.exports